import React from 'react';
import { deletePages, getPages, getBlocks } from './../../Services/Api.service';
import { string, object } from 'yup';
import { translate } from '../../../Services/translation';

export const pagesModel = {
    root: 'pages',
    item: 'page',
    title: "Pages",
    systemId: "id",
    forbidCreateNew: true,
    forbidEditAction: true,
    forbidShowBlockAction: true,
    forbidDeleteAction: true,

    deleteRequest: deletePages,
    requestBlockData: getBlocks,
    getData: getPages,

    children: [
        {
            root: 'articles',
            item: 'article'
        },
        {
            root: 'employees',
            item: 'employee',
        }
    ],
    headers: [{
        headerName: "externalLink",
        label: "External Link",
        typeName: "Url",
        isHiddenInIndex: true,
        isHiddenInForm: true,
        isDisabled: true
    }, {
        headerName: "externalLinkName",
        label: "External Link Name",
        typeName: "String",
        isHiddenInIndex: true,
        isHiddenInForm: true,
        isDisabled: true
    }, {
        headerName: "name",
        label: "Name",
        typeName: "String",
        isHiddenInIndex: false,
        isHiddenInForm: false,
        isDisabled: false
    }, {
        headerName: "internalPage",
        label: "Internal Page",
        typeName: "String",
        isHiddenInIndex: true,
        isHiddenInForm: true,
        isDisabled: true
    }, {
        headerName: "pageType",
        label: "Page Type",
        typeName: "String",
        isHiddenInIndex: false,
        isHiddenInForm: false,
        isDisabled: false
    }
    ],
    validation: object().shape({
        name: string().required(translate(`validation.required`)),
        pageType: string().required(translate(`validation.required`))
    })
}